export const VFX_SPRITE_FRAME_ANCHOR_DATA: Record<
  string,
  { x: number; y: number }
> = {
  "/assets/spells/tile-fx/electric-1.png": { x: 0.5, y: 0.9 },
  "/assets/spells/projectile/water-gun.png": { x: 0, y: 0.5 },
  "/assets/spells/tile-fx/psychic-4.png": { x: 0.5, y: 0.9 },
  "/assets/spells/tile-fx/flying-1b.png": { x: 0.5, y: 0.75 },
  "/assets/spells/tile-fx/vine_whip_upwards_000__12.png": { x: 0.5, y: 0.75 },
  "/assets/spells/self/healing-2-green.png": { x: 0.5, y: 0.85 },
  "/assets/spells/tile-fx/ice-1.png": { x: 0.5, y: 0.9 },
  "/assets/spells/tile-fx/dark-3.png": { x: 0.5, y: 0.9 },
  "/assets/spells/tile-fx/poison-1.png": { x: 0.5, y: 0.9 },
};
